import React, { useRef, useState, useEffect } from "react";


import Modal from "react-bootstrap/Modal";
import moment from "moment";
import axios from "axios";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  seleccionarCampo,
  round,
  validarCantidad,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
/* import CatalogoProductoExistencia from "../../catalogos/catalogoProductoExistencia"; */
import CatalogoProducto from "../../catalogos/catalogoProductosAlmacen";
import CatalogoProductoExistencia from "../../catalogos/catalogoProductosExistencia";
import CatalogoUbicacion from "../../catalogos/catalogoUbicacion";


export const IncluirProducOper = (props) => {
  const token = localStorage.getItem("jwtToken");
  const op = require("../../../src/modulos/datos");
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

  /*  variables de referencias */
  const btnCancelar = useRef();
  const btnAcepta = useRef();
  const txtIdproducto = useRef();
  const txtIdUbicacion = useRef();
  const txtDescriUbi = useRef();
  const txtIdUbicacionDest = useRef();
  const txtDescriUbiDest = useRef();
  const txtNombre = useRef();
  const txtCantidad = useRef();
  const txtCantidadExistente = useRef();
  const txtPrecio = useRef();
  const cmbTipoMovimiento = useRef();
  const txtFechaVenc = useRef();
  const txtFecha = useRef();
  const txtNumFactura = useRef();
  const cmbUnidad = useRef();

  /*  variables de estados */
  const [body, setBody] = useState(null);
  const [tipoIngreso, setTipoIngreso] = useState([]);
  const [catalogoProducto, setCatalogoProducto] = useState(false);
  const [catalogoProductoE, setCatalogoProductoE] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [labelFecha, setLabelFecha] = useState("Fecha:");
  const [unidadCombo, setUnidadCombo] = useState([]);
  const [catalogoUbicacion, setCatalogoUbicacion] = useState(false);
  const [tipoUbi, setTipoUbi] = useState(0);
  const [producto, setProducto] = useState({
    idproducto: null,
    codigo: null,
    cantidad: 1.0,
    cantidadE: 0.0,
    cantidadEA: 0.0,
    nombrecorto: null,
    precio: 0.0,
    preciomaxi: 0.0,
    precioofe: 0.0,
    preciomayor: 0.0,
    preciomini: 0.0,
    preciomaxialter: 0.0,
    precioofealter: 0.0,
    preciomayoralter: 0.0,
    preciominialter: 0.0,
    preciobs: 0.0,
    iva: 0.0,
    montoiva: 0.0,
    descuento: 0.0,
    total: 0.0,
    unidad: [],
    idunidadmedida: null,
    idunidadalterna: null,
    descripcionuni: "",
    descripcionunialt: "",
    precioconiva: 0.0,
    idmoneda: null,
    valormoneda: 0.0,
    tipounidad: null,
    tipofactor: null,
    valorfactor: 0.0,
    tipoprecio: null,
    fechavencimiento: null,
    tipomovimiento: null,
    fechatipomovimiento: null,
    numfactura: null,
  });
  const [habilitadoFec, setHabilitadoFec] = useState(true);
  const [habilitadoFac, setHabilitadoFac] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fechaven") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
        cmbTipoMovimiento.current.focus();
      } else if (event.target.name === "fecha") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
        if (habilitadoFac) {
          txtNumFactura.current.focus();
        } else {
          btnAcepta.current.focus();
        }
      }
      if (event.target.name === "numfactura") {
        btnAcepta.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fechaven") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
      } else if (event.target.name === "fecha") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const validarCantidadP = (event) => {
    event.preventDefault();
    validaMonto(event);
    if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
      event.target.value = '0,00'
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      let cantidades = validarCantidad({
        index: 0,
        event: event,
        productos: [producto],
        tipo: props.tipo,
      });
      console.log(cantidades.data[0])
      setMensaje(cantidades.msm);
      // setProducto(cantidades.data[0]);

      if (cantidades.msm.mostrar) {
        btnCancelar.current.focus();
      } else {
        if (event.which === 13) {
          txtFechaVenc.current.focus();
        }
      }
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    console.log('hola si paso')
    let valido = true;
    if (txtIdproducto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El código no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      txtIdproducto.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Descripción del Producto no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      txtNombre.current.focus();
    } else if (txtDescriUbi.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Ubicación en el Almacen no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      txtIdUbicacion.current.focus();
    } else if (props.tipoope === 3 && txtDescriUbiDest.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Ubicación destino en el almacen no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      txtIdUbicacionDest.current.focus();
    } else if (txtCantidad.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Cantidad no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (txtCantidad.current.value.trim() === "0,00") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Cantidad no debe cero",
        icono: "informacion",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (
      props.tipoope >= 2 &&
      parseFloat(txtCantidad.current.value.replace(/\./g, "").replace(",", ".")) >
      parseFloat(
        txtCantidadExistente.current.value.replace(/\./g, "").replace(",", ".")
      )
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La  cantidad no debe ser mayor a la cantidad existente",
        icono: "informacion",
      });
      valido = false;
      txtCantidad.current.focus();
    } else if (
      (props.tipoope >= 2) &
      (txtFecha.current.value.trim() === "") &
      (cmbTipoMovimiento.current.selectedIndex === 0)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      txtFecha.current.focus();
    } else if (
      (txtFecha.current.value.trim() === "") &
      (cmbTipoMovimiento.current.selectedIndex >= 1)
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      txtFecha.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      valido = false;
      txtFecha.current.focus();
    } else if ((txtNumFactura.current.value.trim() === "") & habilitadoFac) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Numero de factura no debe estar vacio",
        icono: "informacion",
      });
      valido = false;
      txtNumFactura.current.focus();
    }

    console.log(producto)
    if (valido) {
      let datos = [];
      datos.push({
        idproducto: producto.idproducto,
        codigo: producto.codigo,
        descripcion: producto.descripcion,
        cantidad: parseFloat(
          txtCantidad.current.value.replace(/\./g, "").replace(",", ".")
        ),

        fechavencimiento: txtFechaVenc.current.value,
        tipomovimiento:
          cmbTipoMovimiento.current[cmbTipoMovimiento.current.selectedIndex]
            .text,
        fechatipomovimiento: txtFecha.current.value,
        numfactura: txtNumFactura.current.value,
        tipounidad: producto.tipounidad,
        idunidadmedida: producto.idunidadmedida,
        idunidadalterna: producto.idunidadalterna,
        descripcionuni: producto.descripcionuni,
        descripcionunialt: producto.descripcionunialt,
        tipofactor: producto.tipofactor,
        valorfactor: producto.valorfactor,
        valormoneda: producto.valormoneda,
        idubicacion: txtIdUbicacion.current.value,
        idubicaciondest: txtIdUbicacionDest.current.value,
      });

      setBody(datos);

      let sigue = true;

      for (let i = 0; i < props.productos.length; i++) {
        if (props.productos[i].idproducto === producto.idproducto) {
          sigue = false;
          setMensaje({
            mostrar: true,
            titulo: "NOTIFICACIÓN",
            texto: 'Este producto ya esta agregado a la operación de inventario.',
            icono: "informacion",
          });
        }
      }


      if (sigue) {
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: "Esta Seguro de Agregar este Producto.",
          icono: "confirmacion",
        });
      }
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    console.log(body)
    props.onHideAcepta(body[0]);
    blanquear();
  };

  const blanquear = () => {
    setActivate(false);
    setOperacion(0);
    setTipoIngreso([]);
    setLabelFecha("Fecha:");
    setUnidadCombo([]);
    setProducto({
      idproducto: null,
      codigo: null,
      cantidad: 1.0,
      cantidadE: 0.0,
      cantidadEA: 0.0,
      nombrecorto: null,
      precio: 0.0,
      preciomaxi: 0.0,
      precioofe: 0.0,
      preciomayor: 0.0,
      preciomini: 0.0,
      preciomaxialter: 0.0,
      precioofealter: 0.0,
      preciomayoralter: 0.0,
      preciominialter: 0.0,
      preciobs: 0.0,
      iva: 0.0,
      montoiva: 0.0,
      descuento: 0.0,
      total: 0.0,
      unidad: [],
      idunidadmedida: null,
      idunidadalterna: null,
      descripcionuni: "",
      descripcionunialt: "",
      precioconiva: 0.0,
      idmoneda: null,
      valormoneda: 0.0,
      tipounidad: null,
      tipofactor: null,
      valorfactor: 0.0,
      tipoprecio: null,
      fechavencimiento: null,
      tipomovimiento: null,
      fechatipomovimiento: null,
      numfactura: null,
    });
  };

  const habilitarCampoTipoMov = () => {
    switch (parseInt(cmbTipoMovimiento.current.value)) {
      case 1:
        if (props.tipoope == 1) {
          setLabelFecha("Fecha:");
          txtFecha.current.value = moment.utc(fechasistema).format("YYYY-MM-DD");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          btnAcepta.current.focus();
        } else {
          setLabelFecha("Fecha de Salida:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }

        break;
      case 2:
      case 3:
      case 4:
        if (props.tipoope == 1) {
          if (cmbTipoMovimiento.current.selectedIndex === 1) {
            setLabelFecha("FECHA DE DONACION:");
          } else if (cmbTipoMovimiento.current.selectedIndex === 2) {
            setLabelFecha("FECHA DE PRESTAMO:");
          } else {
            setLabelFecha("FECHA DE RESGUARDO:");
          }
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        } else if (props.tipoope == 3) {
          setLabelFecha("FECHA DE TRASLADO:");
          setHabilitadoFec(true);
          setHabilitadoFac(true);
          txtFecha.current.focus();
        } else {
          if (cmbTipoMovimiento.current.selectedIndex === 1) {
            setLabelFecha("FECHA DE VENCIMIENTO:");
          } else if (cmbTipoMovimiento.current.selectedIndex === 2) {
            setLabelFecha("FECHA DE DEVOLUCION:");
          } else {
            setLabelFecha("FECHA DE PRESTAMO:");
          }
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }

        break;

      case 5:
        if (props.tipoope == 1) {
          setLabelFecha("FECHA DE ADQUISICION:");
          setHabilitadoFec(true);
          setHabilitadoFac(true);
          txtFecha.current.focus();
        } else {
          setLabelFecha("FECHA DE DONACION:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }

        break;

      case 6:
        if (props.tipoope == 1) {
          setLabelFecha("FECHA DE PRODUCCION:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        } else if (props.tipoope == 2) {
          setLabelFecha("FECHA DE AJUSTE:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }
        break;
      case 7:
        if (props.tipoope == 1) {
          setLabelFecha("FECHA DE AJUSTE:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.focus();
        }
        break;
    }
  };

  const onChange = (e) => {
    if (e.target.name === "tipo") {
      habilitarCampoTipoMov();
    }
  };

  const onCambioUnidad = (e) => {
    let data = producto;
    let precio = 0.0;
    let montoiva = 0.0;
    let tipounidad = 0;
    let cantie = data.cantidadEA;
    let idunidad = e.target.value;
    let uni = [];

    if (parseInt(idunidad) === parseInt(data.idunidadalterna)) {
      tipounidad = 1;
      cantie = parseFloat(data.cantidadEA);
      cantie = Math.trunc(cantie);

      if (parseInt(data.tipoprecio) === 1) {
        precio = parseFloat(data.preciomaxialter);
      } else if (parseInt(data.tipoprecio) === 2) {
        precio = parseFloat(data.precioofealter);
      } else if (parseInt(data.tipoprecio) === 3) {
        precio = parseFloat(data.preciomayoralter);
      } else if (parseInt(data.tipoprecio) === 4) {
        precio = parseFloat(data.preciominialter);
      }
    } else if (parseInt(idunidad) === parseInt(data.idunidadmedida)) {
      tipounidad = 0;
      cantie = parseFloat(data.cantidadEA / data.valorfactor);
      cantie = Math.trunc(cantie);

      if (parseInt(data.tipoprecio) === 1) {
        precio = parseFloat(data.preciomaxi);
      } else if (parseInt(data.tipoprecio) === 2) {
        precio = parseFloat(data.precioofe);
      } else if (parseInt(data.tipoprecio) === 3) {
        precio = parseFloat(data.preciomayor);
      } else if (parseInt(data.tipoprecio) === 4) {
        precio = parseFloat(data.preciomini);
      }
    }

    montoiva = (precio * parseFloat(data.iva)) / 100;
    montoiva = round(montoiva, 2);

    if (props.tipoope === 2 || props.tipoope === 3) {
      if (parseFloat(data.cantidad) > cantie) {
        data.cantidad = 1.0;
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La  cantidad no debe ser mayor a la cantidad existente",
          icono: "informacion",
        });
      }
    }

    data.tipounidad = tipounidad;
    data.precio = precio;
    data.unidad = data.unidad.reverse();
    data.total = precio * data.cantidad;
    data.montoiva = montoiva * data.cantidad;
    data.cantidadE = cantie;
    console.log(data)
    setProducto(data);

    txtCantidadExistente.current.value = formatMoneda(
      cantie.toString().replace(",", "").replace(".", ","),
      ",",
      ".",
      2
    );

  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarProductoInv = (tecla, idalma, idubi, llamado) => {
    let codigoproduct = txtIdproducto.current.value !== "" ? txtIdproducto.current.value.toUpperCase() : "0";

    let endpoint = `${op.conexion}/api/comprasAlmacen/seleccionarproductoinv?tipo=${props.tipo}&idproducto=${codigoproduct}&idalmacen=${idalma}&idubicacion=${idubi}`;
    console.log(endpoint)
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let prod;
          if (response.data !== "") {
            if (llamado === 1) {
              console.log(response.data)
              setProducto(response.data)
              txtIdproducto.current.value = response.data.idproducto;
              txtNombre.current.value = response.data.descripcion;
              txtCantidadExistente.current.value = response.data.cantidad ? formatMoneda(response.data.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2) : '0,00';
              cmbUnidad.current.value = parseInt(response.data.idunidadmedida.toString())
              if (tecla === 13) {
                txtIdUbicacion.current.focus();
              }
            } else {
              txtCantidadExistente.current.value = response.data.cantidad ? formatMoneda(response.data.cantidad.toString().replace(",", "").replace(".", ","), ",", ".", 2) : '0,00';
              if (tecla === 13) {
                if (props.tipoope === 3) {
                  txtIdUbicacionDest.current.focus();
                } else {
                  txtCantidad.current.focus();
                }
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "no existe un producto con ese codigo en el almacen.",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarUbicacion = (tecla, idubi, idalma, llamado) => {
    let campos = "*";
    let nomtab = "ubicacion";
    let nomid = "idubicacion";
    let nomid2 = "idalmacen";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idubi}&nomid2=${nomid2}&id2=${parseInt(idalma)}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (llamado === 2) {
            txtDescriUbiDest.current.value = "";
          } else {
            txtDescriUbi.current.value = "";
          }
          if (response.data.length > 0) {
            if (llamado === 1) {
              txtIdUbicacion.current.value = idubi;
              txtDescriUbi.current.value = response.data[0].descripcionubicacion.trim();
              //txtIdUbicacion.current.setAttribute("disabled", true);
              /* if (tecla === 13) {
                if (props.tipoope === 3) {
                  txtIdUbicacionDest.current.focus();
                } else {
                  txtCantidad.current.focus();
                }
              } */
              if (txtIdproducto.current.value !== "") {
                seleccionarProductoInv(tecla, props.idalmacen, idubi, 2);
              }
              
            } else {
              txtIdUbicacionDest.current.value = idubi;
              txtDescriUbiDest.current.value = response.data[0].descripcionubicacion.trim();
              if (tecla === 13) {
                txtCantidad.current.focus();
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una ubicacion con este codigo",
              icono: "informacion",
            });
            if (llamado === 2) {
              txtIdUbicacionDest.current.value = "";
              txtDescriUbiDest.current.value = "";
            } else {
              txtIdUbicacion.current.value = "";
              txtDescriUbi.current.value = "";
            }

          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarProducto = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    txtNombre.current.value = "";
    txtCantidadExistente.current.value = "0,00";
    txtCantidad.current.value = "0,00";
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarProductoInv(event.which, props.idalmacen, txtIdUbicacion.current.value === "" ? 0 : txtIdUbicacion.current.value, 1);
      }
    }
  };

  const validarUbicacion = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    let idalma = 0;
    let llamado = 0;
    if (event.target.name === "codubicacion") {
      txtDescriUbi.current.value = "";
      txtCantidadExistente.current.value = "0,00";
      idalma = props.idalmacen;
      llamado = 1;
    } else if (event.target.name === "codubicaciondest") {
      txtDescriUbiDest.current.value = "";
      idalma = props.idalmacendest;
      llamado = 2;
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarUbicacion(event.which, event.target.value, idalma, llamado);
      }
    }
  };

  const onCatalogoProducto = (values) => {
    setCatalogoProducto(false);
    setCatalogoProductoE(false);

    txtIdproducto.current.value = values;
    if (props.tipoope === 1) {
      seleccionarProductoInv(13, props.idalmacen, txtIdUbicacion.current.value === "" ? 0 : txtIdUbicacion.current.value, 1);
    } else {
      seleccionarProductoInv(13, props.idalmacen, txtIdUbicacion.current.value === "" ? 0 : txtIdUbicacion.current.value, 1);
    }
  };

  const onCatalogoUbicacion = (values) => {
    setCatalogoUbicacion(false);
    if (tipoUbi === 1) {
      seleccionarUbicacion(13, values, props.idalmacen, 1);
    } else if (tipoUbi === 2) {
      seleccionarUbicacion(13, values, props.idalmacendest, 2);
    }

  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  const seleccionarUnidadMedida = () => {
    let campos = "*";
    let nomtab = "unidadmedida";
    let orden = "idunidadmedida";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setUnidadCombo(response.data);

        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  useEffect(() => {
    if (props.tipoingreso) {
      setTipoIngreso(props.tipoingreso);
    }
  }, [props.tipoingreso]);

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      style={{ backgroundColor: "rgb(0, 0, 0,0.5)" }}
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarUnidadMedida()
        setOperacion(props.operacion);
        if (props.operacion === 1) {
          txtIdproducto.current.focus();
        } else {
          txtIdproducto.current.value = props.registro.idproducto;
          txtCantidad.current.value = formatMoneda(
            props.registro.cantidad
              .toString()
              .replace(",", "")
              .replace(".", ","),
            ",",
            ".",
            2
          );
          txtFechaVenc.current.value =
            props.registro.fechavencimiento === ""
              ? ""
              : moment.utc(props.registro.fechavencimiento).format("DD/MM/YYYY");
          txtFecha.current.value =
            props.registro.fechatipomovimiento === ""
              ? ""
              : moment.utc(props.registro.fechatipomovimiento).format("DD/MM/YYYY");
          txtNumFactura.current.value = props.registro.numfactura.trim();
          for (let i = 0; i < props.tipoingreso.length; i++) {
            if (
              props.tipoingreso[i].descripcion === props.registro.tipomovimiento
            ) {
              cmbTipoMovimiento.current.selectedIndex = i; //props.tipoingreso[i].idtipo;
              break;
            }
          }
          habilitarCampoTipoMov();
          //txtCantidad.current.focus();
          seleccionarProductoInv(13, props.idalmacen, txtIdUbicacion.current.value === "" ? 0 : txtIdUbicacion.current.value, 1);
        }
        setTipoIngreso(props.tipoingreso);
        if (props.tipoope === 1) {
          // txtFecha.current.value = "";
          txtFecha.current.value = moment.utc(fechasistema).format("YYYY-MM-DD");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
        } else if (props.tipoope == 3) {
          setLabelFecha("FECHA DE TRASLADO:");
          setHabilitadoFec(true);
          setHabilitadoFac(false);
          txtFecha.current.value = moment.utc(fechasistema).format("YYYY-MM-DD");
        } else {
          txtFecha.current.value = moment.utc(fechasistema).format("YYYY-MM-DD");
          // txtFecha.current.value = "";
          setHabilitadoFec(true);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          {props.operacion === 1
            ? "Agregar Productos."
            : props.operacion === 2
              ? "Editar Productos."
              : props.operacion === 3
                ? "Eliminar Productos."
                : "Consultar Productos."}
        </Modal.Title>
        <button
          ref={btnCancelar}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} >
        </Dimmer>

        <CatalogoProductoExistencia
          show={catalogoProductoE}
          onHideCancela={() => setCatalogoProductoE(false)}
          onHideAcepta={onCatalogoProducto}
          idalmacen={props.idalmacen}
        />

        <CatalogoProducto
          show={catalogoProducto}
          onHideCancela={() => setCatalogoProducto(false)}
          onHideAcepta={onCatalogoProducto}
        />
        <CatalogoUbicacion
          show={catalogoUbicacion}
          onHideCancelar={() => {
            setCatalogoUbicacion(false);
          }}
          onHideAceptaCatalogo={onCatalogoUbicacion}
          idalmacen={tipoUbi === 1 ? parseInt(props.idalmacen) : parseInt(props.idalmacendest)}
        />
        <div className="border-azul py-3 rounded">

          <div className="row rounded m-0">
            <div className="col-md-12 mb-1">
              <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-lflex justify-content-between">
                <legend className="float-none w-auto fw-bold">
                  Productos
                </legend>

                <div className="input-group input-group-sm mb-1 col-md-2 ">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    Código:
                  </label>
                  <input
                    type="text"
                    ref={txtIdproducto}
                    autoComplete="off"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    onChange={(e) =>
                      (e.target.value = e.target.value.toUpperCase())
                    }
                    onKeyUp={validarProducto}
                    onBlur={validarProducto}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      if (props.tipoope === 1) {
                        setCatalogoProducto(true);
                      } else {
                        setCatalogoProductoE(true);
                      }
                    }}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                <div className="input-group input-group-sm mb-1 col-md-10">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    Descripción:
                  </label>
                  <input
                    type="text"
                    disabled
                    ref={txtNombre}
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                  />
                </div>
              </fieldset>
              <fieldset className=" row col-sm-12 mx-auto border-azul rounded d-lflex justify-content-between">
                <legend className="float-none w-auto fw-bold">
                  Ubicacion
                </legend>

                <div className="input-group input-group-sm mb-1 col-md-2 ">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    Origen:
                  </label>
                  <input
                    type="text"
                    ref={txtIdUbicacion}
                    name="codubicacion"
                    autoComplete="off"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    onKeyUp={validarUbicacion}
                    onBlur={validarUbicacion}

                  />
                  <button
                    type="button"
                    onClick={() => { setCatalogoUbicacion(true); setTipoUbi(1) }}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                <div className="input-group input-group-sm mb-1 col-md-10" >
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    Descripción:
                  </label>
                  <input
                    type="text"
                    disabled
                    ref={txtDescriUbi}
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                  />
                </div>
                <div className="input-group input-group-sm mb-1 col-md-2 " style={{ visibility: props.tipoope === 3 ? 'visible' : 'hidden' }}>
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    Destino:
                  </label>
                  <input
                    type="text"
                    ref={txtIdUbicacionDest}
                    name="codubicaciondest"
                    autoComplete="off"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    onKeyUp={validarUbicacion}
                    onBlur={validarUbicacion}

                  />
                  <button
                    type="button"
                    onClick={() => { setCatalogoUbicacion(true); setTipoUbi(2) }}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                <div className="input-group input-group-sm mb-1 col-md-10" style={{ visibility: props.tipoope === 3 ? 'visible' : 'hidden' }}>
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                  >
                    Descripción:
                  </label>
                  <input
                    type="text"
                    disabled
                    ref={txtDescriUbiDest}
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                  />
                </div>
              </fieldset>

            </div>

            <div className="input-group input-group-sm mb-1 col-md-4 ">
              <label
                className="input-group-text"
                id="inputGroup-sizing-default"
              >
                Cantidad Actual:
              </label>
              <input
                type="text"
                disabled
                ref={txtCantidadExistente}
                className="form-control text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                defaultValue={"0,00"}
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-4">
              <label
                className="input-group-text"
                id="inputGroup-sizing-default"
              >
                Cantidad:
              </label>
              <input
                type="text"
                ref={txtCantidad}
                autoComplete="off"
                className="form-control text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                id="cantidad"
                onFocus={seleccionarCampo}
                onKeyUp={validarCantidadP}
                onBlur={validarCantidadP}
                defaultValue={"0,00"}
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-4">
              <label
                className="input-group-text"
                id="inputGroup-sizing-default"
              >
                Fecha/Vencimiento:
              </label>
              <input
                type="date"
                ref={txtFechaVenc}

                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                name="fechaven"
                onKeyUp={handleInputChange}
                onBlur={handleInputChange}
              />
            </div>

            <div className="input-group input-group-sm mb-1 col-md-4">
              <label
                className="input-group-text"
                id="inputGroup-sizing-default"
              >
                Unidad/Medida:
              </label>
              <select
                ref={cmbUnidad}
                className="form-select"
                aria-label="Default select example"
                name="tipo"
                onChange={onCambioUnidad}
              >
                {unidadCombo.map((unid, x) => (
                  <option key={x} value={unid.idunidadmedida}>
                    {" "}
                    {unid.descripcion}{" "}
                  </option>
                ))}
              </select>
            </div>

            <div className="input-group input-group-sm mb-1 col-md-4">
              <label
                className="input-group-text"
                id="inputGroup-sizing-default"
              >
                Tipo de Movimiento:
              </label>
              <select
                ref={cmbTipoMovimiento}
                className="form-select "
                aria-label="Default select example"
                name="tipo"
                onChange={onChange}
              >
                {tipoIngreso &&
                  tipoIngreso.map((tipo) => (
                    <option key={tipo.idtipo} value={tipo.idtipo}>
                      {tipo.descripcion}
                    </option>
                  ))}
              </select>
            </div>



            {labelFecha === "Fecha:" ? (
              <div className="input-group input-group-sm mb-1 col-md-4">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  {labelFecha}
                </label>
                <input
                  type="date"
                  disabled={!habilitadoFec}
                  ref={txtFecha}
                  defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  name="fecha"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>
            ) : (
              <div className="input-group input-group-sm mb-1 col-md-4">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  {labelFecha}
                </label>
                <input
                  type="date"
                  disabled={!habilitadoFec}
                  ref={txtFecha}
                  defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  name="fecha"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>
            )}

            <div className="col-md-8"></div>
            <div className="input-group input-group-sm mb-1 col-md-4">
              <label
                className="input-group-text"
                id="inputGroup-sizing-default"
              >
                Factura N°:
              </label>
              <input
                type="text"
                disabled={!habilitadoFec}
                ref={txtNumFactura}
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-default"
                name="numfactura"
                onKeyUp={handleInputChange}
              />
            </div>
          </div>

        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success "
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancelar}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill "
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
